import { lazy } from 'react';

const SupportTicketView = lazy(() => import('./SupportTicketView'));

export default SupportTicketView;
